import { API_BASE_URL } from "@/src/services/api";
function ensureApiBase() {
  if (!API_BASE_URL) {
    throw new Error("Saved items API base URL is not configured. Set NEXT_PUBLIC_API_BASE_URL in your environment.");
  }
}
async function parseError(response) {
  try {
    const value = await response.json();
    if (value?.message) {
      if (Array.isArray(value.message)) {
        return value.message.join(", ");
      }
      return String(value.message);
    }
  } catch {
    // fall through
  }
  return response.statusText || "Request failed";
}
export async function createSavedItem(token, payload) {
  ensureApiBase();
  const response = await fetch(`${API_BASE_URL}/saved`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(payload)
  });
  if (!response.ok) {
    throw new Error(await parseError(response));
  }
  return normalizeSavedItem(await response.json());
}
export async function deleteSavedItem(token, type, resourceId) {
  ensureApiBase();
  const response = await fetch(`${API_BASE_URL}/saved/${encodeURIComponent(type)}/${encodeURIComponent(resourceId)}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  if (!response.ok && response.status !== 204) {
    throw new Error(await parseError(response));
  }
}
function normalizeSavedItem(item) {
  const normalizedId = String(item.resourceId || "").trim().toLowerCase();
  const normalizedSlug = String(item.resourceSlug || "").trim().toLowerCase();
  return {
    ...item,
    resourceId: normalizedId,
    resourceSlug: normalizedSlug || null,
    resourceTitle: nullishToNull(item.resourceTitle),
    resourceSummary: nullishToNull(item.resourceSummary),
    resourceImage: nullishToNull(item.resourceImage),
    meta: item.meta ?? null
  };
}
function nullishToNull(value) {
  return value ?? null;
}